import dayjs from 'dayjs'
import isEmpty from 'lodash/isEmpty'
import { createSelector } from 'reselect'
import { formatToRuLocaleString, getUTCTime } from '../utils'

const getShoppingCart = state => state.shoppingCart

export const selectDates = createSelector(getShoppingCart, shoppingCart => {
    const { startDate, endDate } = shoppingCart

    return startDate && endDate
        ? {
              startDate: startDate,
              endDate: endDate,
              nights: dayjs(endDate).diff(startDate, 'days')
          }
        : {
              startDate: '',
              endDate: '',
              nights: ''
          }
})

export const selectRooms = createSelector(
    getShoppingCart,
    shoppingCart =>
        !isEmpty(shoppingCart.rooms)
            ? shoppingCart.rooms.map(room => ({
                  ...room,
                  totalPrice: room.count * room.price
              }))
            : []
)

export const selectRoomsForPayload = createSelector(getShoppingCart, shoppingCart => {
    if (!isEmpty(shoppingCart.rooms)) {
        const rooms = []

        shoppingCart.rooms.forEach(room => {
            for (let i = 1; i <= room.count; i++) {
                rooms.push({
                    arrival: getUTCTime(shoppingCart.startDate),
                    departure: getUTCTime(shoppingCart.endDate),
                    invoice: room.price,
                    categoryId: room.id
                })
            }
        })

        return rooms
    } else {
        return []
    }
})

export const selectTotalInvoice = createSelector(
    getShoppingCart,
    shoppingCart =>
        !isEmpty(shoppingCart.rooms)
            ? shoppingCart.rooms.reduce((prev, curr) => {
                  const totalPrice = curr.count * curr.price
                  return prev + totalPrice
              }, 0)
            : 0
)



// WEBPACK FOOTER //
// ./selectors/shoppingCardSelector.js